import store from './../store'

export default {
  path: '/tradies',
  name: 'tradies',
  redirect: { name: 'tradies.list-page' },
  component: () => import('@/views/tradies/index.vue'),
  children: [
    {
      path: '/tradies',
      name: 'tradies.list-page',
      component: () => import('@/views/tradies/ListPage.vue'),
    },
    {
      path: '/tradies/:tradieId',
      name: 'tradies.view-tradie',
      component: () => import('@/views/tradies/ViewTradie.vue'),
    },
  ],
  beforeEnter: async (to, from, next) => {
    if (store.state.auth.user) {
      if (store.state.auth.user.user_type !== 'business_admin')
        return next({ name: 'page-not-found' })
      return next()
    }
    store
      .dispatch('auth/getAuthenticatedUser')
      .then(() => {
        if (store.state.auth.user.user_type !== 'business_admin')
          next({ name: 'page-not-found' })
        else next()
      })
      .catch(() => next({ name: 'auth.login-page' }))
  },
}
